/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectedWinner
 */
export interface RejectedWinner {
    /**
     * 
     * @type {string}
     * @memberof RejectedWinner
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof RejectedWinner
     */
    notes: string;
    /**
     * 
     * @type {string}
     * @memberof RejectedWinner
     */
    adminId: string;
}

/**
 * Check if a given object implements the RejectedWinner interface.
 */
export function instanceOfRejectedWinner(value: object): value is RejectedWinner {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('adminId' in value) || value['adminId'] === undefined) return false;
    return true;
}

export function RejectedWinnerFromJSON(json: any): RejectedWinner {
    return RejectedWinnerFromJSONTyped(json, false);
}

export function RejectedWinnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectedWinner {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'notes': json['notes'],
        'adminId': json['adminId'],
    };
}

export function RejectedWinnerToJSON(json: any): RejectedWinner {
    return RejectedWinnerToJSONTyped(json, false);
}

export function RejectedWinnerToJSONTyped(value?: RejectedWinner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'notes': value['notes'],
        'adminId': value['adminId'],
    };
}

